export default __webpack_public_path__ + "static/media/CNo.15-0.29fcf3e9.jpg";